import PropTypes from 'prop-types';
import InputAdornment from '@mui/material/InputAdornment';
import { useTheme } from '@mui/material/styles';
import { getDirhamSymbolSizePx } from 'utils/currency';
import DirhamSymbol from './DirhamSymbol';

export default function CurrencyInputAdornment({ size, position = 'start' }) {
  const theme = useTheme();
  const iconPx = size ?? getDirhamSymbolSizePx('body2', theme);

  return (
    <InputAdornment
      position={position}
      sx={{
        mr: position === 'start' ? 0.25 : 0,
        ml: position === 'end' ? 0.25 : 0,
        maxHeight: 'none'
      }}
    >
      <DirhamSymbol size={iconPx} />
    </InputAdornment>
  );
}

CurrencyInputAdornment.propTypes = {
  size: PropTypes.number,
  position: PropTypes.oneOf(['start', 'end'])
};
